import { createContext } from 'react';
import { InboxContextProps } from './Inbox.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const InboxContext = createContext<InboxContextProps>(undefined);

export default InboxContext;
